export const homeObjOne = {
  id: "about",
  lightBg: false,
  lightText: true,
  lightTextDesc: true,
  topLine: "Premium Bank",
  headLine: "Unlimited Transactions with Zero Fees",
  description:
    "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees.",
  buttonLabel: "Get Started",
  imgStart: false,
  //img: require("../images/svg-1.svg").default,
  img: "img1",
  alt: "Car",
  dark: true,
  primary: true,
  darkText: false,
};
export const homeObjTwo = {
  id: "discover",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Unlimited Access",
  headLine: "Unlimited Transactions with Zero Fees",
  description:
    "Get access to our exclusive app that allows you to send unlimited transactions without getting charged any fees.",
  buttonLabel: "Learn More...",
  imgStart: true,
  //img: `url("../images/svg-1.svg")`,
  img: "img2",
  alt: "Piggybank",
  dark: false,
  primary: false,
  darkText: true,
};
export const homeObjThree = {
  id: "signup",
  lightBg: true,
  lightText: false,
  lightTextDesc: false,
  topLine: "Join our Team",
  headLine: "Creating an Account is extremely easy",
  description:
    "Get everything set up and ready in under 10 minutes. All you need to do is add your information and you are ready to go.",
  buttonLabel: "Start Now",
  imgStart: false,
  img: "img3",
  //img: `url("../images/svg-1.svg")`,
  alt: "Car",
  dark: false,
  primary: false,
  darkText: true,
};
